import { useState } from 'react';

import { usePolling } from '@/shared/hooks/use-polling';
import { getQueryProgress } from '../api';
import type { QueryProgress } from '../types';

export function useQueryProgress(workspaceId: string, queryId: string, enabled: boolean) {
  const [progress, setProgress] = useState<QueryProgress[]>([]);

  usePolling<QueryProgress[]>({
    enabled,
    queryKey: `query-progress-${workspaceId}-${queryId}`,
    fetcher: () => getQueryProgress(workspaceId, queryId),
    getCompleteCondition: (data) => data.every((item) => item.status === 'completed'),
    interval: 20000,
    onComplete: (data) => {
      setProgress(data);
    },
    onFetched: (data) => {
      setProgress(data);
    },
  });

  return progress;
}
